import SockJS from 'sockjs-client';
import Stomp from 'stompjs';


const events = {}

const invoke = (eventName, data) => {
    const e = events[eventName]
    if (e) {
        e.apply(events, [data])
    }
}

export function bindEvent(event, callback) {
    events[event] = callback
}

let stompClient

export const connect = (id) => {
    if (!(stompClient || {}).connected) {
        let url = '/TobDesign/websocket'
        if (/^tob\.design$/.test(location.host)) {
            url = process.env.VUE_APP_SECONDARY_URL + url
        } else {
            url = process.env.VUE_APP_BASE_URL + url
        }
        stompClient = Stomp.over(new SockJS(url))
        stompClient.debug = null
        stompClient.connect({}, () => {
            console.log('websocket connected')
            // 订阅后端主动推消息到前端的topic
            stompClient.subscribe('/topic/', () => {
                invoke('new_message')
            });
            // 阅后端主动推消息到前端的topic,只有指定的用户(hzb)收到的的消息
            stompClient.subscribe(`/user/${id}/`, (r) => {
                const msg = JSON.parse(r.body)
                if (msg.type === 'pay_result') {
                    invoke('pay_result', msg.data)
                } else {
                    invoke('new_message')
                }
            });
        }, (err) => {
            // 连接发生错误时的处理函数
            console.log(err);
            setTimeout(() => {
                console.log('retry connect');
                connect(id)
            }, 5000)
        })
    }
}

export const disconnect = () => {
    try {
        if ((stompClient || {}).connected) {
            stompClient.disconnect()
        }
    } catch (e) {
        //
    }
}
